var _classCallCheck = require("/mnt/Data/.My_Projects/githubProjects/gpu.rocks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/Data/.My_Projects/githubProjects/gpu.rocks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./export-as-json'),
    convertToPlotlyJSON = _require.getPlotlyJSON,
    convertToChartistJSON = _require.getChartistJSON;

var BenchmarkOut = /*#__PURE__*/function () {
  "use strict";

  /**
   * @param {Boolean} [singleData] whether only a single data object is to be stored
   * @param {*} [initData] initialData
   * @returns {null}
   */
  function BenchmarkOut() {
    var singleData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var initData = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, BenchmarkOut);

    this.singleData = singleData;

    if (singleData) {
      this.data = initData;
    } else {
      this.data = [];

      if (initData) {
        this.data.push(initData);
      }
    }
  }
  /**
   * @method addData
   * @param {Object} newData new data object to be added to a multi-data array
   * @returns {null}
   */


  _createClass(BenchmarkOut, [{
    key: "addData",
    value: function addData(newData) {
      if (!this.singleData) {
        this.data.push(newData);
      } else throw "Single Data";
    }
    /**
     * @method setDataField
     * @param {String} field the field name
     * @param {*} value the field value
     * @param {Number} [index=0] index of the data object in the multi-data array
     * @returns {null}
     */

  }, {
    key: "setDataField",
    value: function setDataField(field, value) {
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (this.singleData) {
        this.data[field] = value;
      } else {
        this.data[index][field] = value;
      }
    }
    /**
     * @method getDataField
     * @param {String} field the field name
     * @param {Number} [index=0] index of the data object in the multi-data array
     * @returns {*}
     */

  }, {
    key: "getDataField",
    value: function getDataField(field) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this.singleData) {
        return this.data[field];
      } else {
        return this.data[index][field];
      }
    }
    /**
     * @method getData
     * @returns {Object}
     */

  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
    /**
     * @description Returns a plotly style array of graphs
     * @param {Array} compare_fields
     */

  }, {
    key: "getPlotlyJSON",
    value: function getPlotlyJSON() {
      var _this = this;

      var compare_fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{
        x: 'matrix_size',
        y: 'gpu_run_time_mat_mult'
      }, {
        x: 'matrix_size',
        y: 'pipe_run_time'
      }, {
        x: 'matrix_size',
        y: 'gpu_score'
      }];

      if (!this.singleData) {
        var retArr = [];
        compare_fields.forEach(function (compareField) {
          retArr.push(convertToPlotlyJSON(_this.data, {
            x: compareField.x,
            y: compareField.y
          }));
        });
        return retArr;
      } else throw "Only possible for multi-data arrays";
    }
    /**
     * @description Returns a plotly style array of graphs
     * @param {Array} compare_fields
     */

  }, {
    key: "getChartistJSON",
    value: function getChartistJSON() {
      var _this2 = this;

      var compare_fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{
        x: 'matrix_size',
        y: 'gpu_run_time_mat_mult'
      }, {
        x: 'matrix_size',
        y: 'pipe_run_time'
      }, {
        x: 'matrix_size',
        y: 'gpu_score'
      }];

      if (!this.singleData) {
        var retArr = [];
        compare_fields.forEach(function (compareField) {
          retArr.push(convertToChartistJSON(_this2.data, {
            x: compareField.x,
            y: compareField.y
          }));
        });
        return retArr;
      } else throw "Only possible for multi-data arrays";
    }
  }]);

  return BenchmarkOut;
}();

module.exports = BenchmarkOut;